
const PeerMentorshipNetworkData = [
    {
        id: 1,
        heading: "My Mentor Helped Me Settle In",
        text: "I was overwhelmed during my first week abroad—housing, course registration, even finding halal food. My mentor walked me through everything. It felt like having a big sister in a new country.",
        name: "Amina, UAE | Psychology, University of Melbourne"
    },
    {
        id: 2,
        heading: "I Got Career Advice I Could Actually Use",
        text: "My mentor helped me tailor my resume for local internships and explained how CPT works. I wouldn’t have figured it out on my own.",
        name: "Hassan, Saudi Arabia | Data Science, Boston University"
    },
    {
        id: 3,
        heading: "It Made Me Feel Less Alone",
        text: "I joined the mentorship Slack group and instantly felt part of a community. We share tips, vent about classes, and even meet up during holidays.",
        name: "Fatima, Oman | Law Student, University of Leeds"
    },
    {
        id: 4,
        heading: "I Got Academic Support Without Feeling Judged",
        text: "I was struggling with participation and writing norms. My mentor explained how to speak up in class and helped me rewrite my first essay. It boosted my confidence.",
        name: "Mohammed, Bahrain | Engineering, University of Toronto"
    },
    {
        id: 5,
        heading: "We Still Talk Every Week",
        text: "My mentor and I started chatting on WhatsApp during onboarding—and we’ve stayed in touch ever since. He checks in before exams and even helped me prep for interviews.",
        name: "Layla, Qatar | Marketing, University of Sydney"
    },
    
];

export default PeerMentorshipNetworkData;